
import {Observable} from 'rxjs';
import {Page} from '../../model/page';
import {EntityModel} from '../model/entity.model';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {HeaderConstants} from '../utils/headers.constants';
import {Filter} from '../filter/filter';

export abstract class BaseService<T extends EntityModel> {

  constructor(protected http: HttpClient) {
  }

  abstract serviceUrl(): string;

  getPage(page = 0, size = 10, sortBy?: string[], sortOrder = 'desc', refresh: boolean = false): Observable<Page<T>> {
    console.info('Loading page', page, size, sortBy, refresh);
    let headersValue = new HttpHeaders();
    if (!refresh) {
      headersValue = headersValue.append(HeaderConstants.CACHED, 'true');
    }
    let paramsValue = new HttpParams().append('page', page.toString()).append('size', size.toString());
    if (sortBy) {
      sortBy.forEach(value => paramsValue = paramsValue.append('sort', `${value},${sortOrder}`));
    }
    const options = {headers: headersValue, params: paramsValue};
    console.info(options);
    return this.http
      .get<Page<T>>(`${this.serviceUrl()}`, options);
  }

  search(model: T, page = 0, size = 10, sortBy?: string, sortOrder = 'desc'): Observable<Page<T>> {
    console.info('Searching ', model, page, size, sortBy);
    let paramsValue = new HttpParams().append('page', page.toString()).append('size', size.toString());
    if (sortBy) {
      paramsValue = paramsValue.append('sort', `${sortBy},${sortOrder}`);
    }
    const options = {params: paramsValue};
    console.info(options);
    return this.http
      .post<Page<T>>(`${this.serviceUrl()}/search-example`, JSON.stringify(model), options);
  }

  searchByFilter(filter: Filter, page = 0, size = 10, sortBy?: string[], sortOrder = 'desc'): Observable<Page<T>> {
    console.info('Searching ', filter, page, size, sortBy);
    let paramsValue = new HttpParams().append('page', page.toString()).append('size', size.toString());
    if (sortBy) {
      sortBy.forEach(value => paramsValue = paramsValue.append('sort', `${value},${sortOrder}`));
    }
    const options = {params: paramsValue};
    console.info(options);
    return this.http
      .post<Page<T>>(`${this.serviceUrl()}/search-filter`, JSON.stringify(filter), options);
  }

  create(model: T): Observable<T> {
    console.info('Creating', JSON.stringify(model));
    return this.http
      .post<T>(this.serviceUrl(), JSON.stringify(model));
  }

  get(id: number): Observable<T> {
    console.info('Getting ', JSON.stringify(id));
    return this.http
      .get<T>(`${this.serviceUrl()}/${id}`);
  }

  update(model: T): Observable<T> {
    console.info('Updating', JSON.stringify(model));
    return this.http
      .put<T>(`${this.serviceUrl()}/${model.id}`, JSON.stringify(model));
  }

  remove(id: number): Observable<string>  {
    console.info('Removing', id);
    return this.http
      .delete(this.serviceUrl() + `/${id}`, {responseType: 'text'});
  }

  removeAll(idsParam: number[]): Observable<string>  {
    console.info('Removing', idsParam);
    return this.http
      .delete(this.serviceUrl() + `/all`, {responseType: 'text', body: {ids: idsParam}});
  }

}
